module.exports = __webpack_public_path__ + "assets/img/fish-idle.cb066bcf.png";